<ion-tabs>
  <ion-tab-bar slot="bottom">
    <ion-tab-button tab="geruestanfrage">
      <ion-icon name="construct-outline"></ion-icon>
      <ion-label>{{ 'GERUESTANFRAGE' | translate }}</ion-label>
    </ion-tab-button>
    <ion-tab-button tab="news">
      <ion-icon name="newspaper-outline"></ion-icon>
      <ion-label>{{ 'NEWS' | translate }}</ion-label>
    </ion-tab-button>
    <ion-tab-button tab="ueber-uns">
      <ion-icon name="information-circle-outline"></ion-icon>
      <ion-label>{{ 'UEBER_UNS' | translate }}</ion-label>
    </ion-tab-button>
    <ion-tab-button tab="mitarbeiter">
      <ion-icon name="people-outline"></ion-icon>
      <ion-label>{{ 'MITARBEITER' | translate }}</ion-label>
    </ion-tab-button>
  </ion-tab-bar>
</ion-tabs>
